<div class="layout-column">
    <div class="flex-layout-row-align-start-start" ngClass.lt-md="mobile-radio-options flex-column">
        <mat-radio-button [checked]="true">Create New</mat-radio-button>
        <mat-radio-button  class="ml-50" ngClass.lt-md="ml-0" [checked]="false" (click)="matchExistingAssets()">Match - Existing Asset(s)</mat-radio-button>
        <mat-radio-button  class="ml-50" ngClass.lt-md="ml-0" [disabled]="matchReviewDisabled()" (click)="matchForReviewAssets()">Match - SyncOnSet Inventory</mat-radio-button>
        <div class="layout-row-end-none" style="margin-left: auto;">
            <button mat-raised-button (click)="splitAsset()">
                <mat-icon svgIcon="call_split"></mat-icon>
            </button>
        </div>
    </div>
    <div style="flex: 1 1 1e-09px;box-sizing: border-box;" >
        <ah-update-trx-form [inputFields]="inputFields" [transactions]="[transaction]"
            [characters]="characters" [sets]="sets" [departments]="departments"
            [subDepartments]="subDepartments" [locations]="locations"
            [dispositions]="dispositions" [excludedDispositions]="excludedDispositions"
            [franchise]="franchise" [projects]="projects" [indexType]="indexType" [isExpandoRow]="true">
        </ah-update-trx-form>
    </div>
</div>
